import type { RecipientResponse, ResponseCallback, SimpleCallback } from 'mmfintech-backend-api/types'
import { useCallback } from 'react'
import CryptoRecipientModal from '../CryptoRecipientModal'
import BankRecipientEdit from '../elements/BankRecipientEdit'
import { InteracRecipientEdit } from '../elements/InteracRecipientEdit'
import { PerfectMoneyRecipientEdit } from '../elements/PerfectMoneyRecipientEdit'
import PixRecipientEdit from '../elements/PixRecipientEdit'
import { WalletRecipientEdit } from '../elements/WalletRecipientEdit'

import './EditRecipientModal.scss'

interface Props {
  recipient: RecipientResponse
  onClose?: SimpleCallback
  onSuccess?: ResponseCallback
  independentEdit?: boolean
}

function EditRecipientModal(props: Props) {
  const { recipient, onClose, onSuccess, independentEdit = false } = props

  const handleClose = useCallback(() => {
    onClose?.()
  }, [onClose])

  const handleSuccess = useCallback(
    (response?: any) => {
      onSuccess?.(response)
      onClose?.()
    },
    [onClose, onSuccess]
  )

  if (recipient?.type.includes('_BANK_ACCOUNT')) {
    return <BankRecipientEdit recipient={recipient} onSuccess={handleSuccess} independentEdit={independentEdit} />
  }

  if (recipient?.type.includes('_CRYPTO_ADDRESS')) {
    return (
      <CryptoRecipientModal
        recipientId={recipient?.paymentInstrumentId}
        currencyCode={recipient?.currency}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    )
  }

  if (recipient?.type.includes('_WALLET_ACCOUNT')) {
    switch (recipient?.walletType) {
      case 'INTERAC':
        return (
          <InteracRecipientEdit
            recipientId={recipient?.paymentInstrumentId}
            currencyCode={recipient?.currency}
            onClose={handleClose}
            onSuccess={handleSuccess}
          />
        )

      case 'JETON_WALLET':
        return (
          <WalletRecipientEdit
            recipientId={recipient?.paymentInstrumentId}
            walletType={recipient?.walletType}
            currencyCode={recipient?.currency}
            onClose={handleClose}
            onSuccess={handleSuccess}
          />
        )

      case 'PERFECT_MONEY':
        return (
          <PerfectMoneyRecipientEdit
            recipientId={recipient?.paymentInstrumentId}
            currencyCode={recipient?.currency}
            onClose={handleClose}
            onSuccess={handleSuccess}
          />
        )

      case 'PIX':
        return (
          <PixRecipientEdit
            recipientId={recipient?.paymentInstrumentId}
            currencyCode={recipient?.currency}
            onClose={handleClose}
            onSuccess={handleSuccess}
          />
        )

      default:
        handleClose()
        return null
    }
  }

  return null
}

export default EditRecipientModal
